import { useState } from 'react';
import { ModuleSlider } from '../../common/map';
import { useAuth } from '../../contexts/AuthContext';
import { getClientType, getCompany } from '../../tools/session/clientSession';
import McClientLogo from './McClientLogo';
import MysteryClientDashboard from './MysteryClientDashboard';
import './styles/global.css';

/** Supervisors open on the client they are logged in as; client_type is the last resort. */
const resolveHostCompany = (user) => {
  const clientType = getClientType();
  return user?.company
    || getCompany()
    || (clientType && clientType !== 'default' ? clientType : '')
    || '';
};

function MysteryClient() {
  const { user } = useAuth();
  const [leftPanelOpen, setLeftPanelOpen] = useState(false);

  return (
    <>
      <section className="mc-module" aria-label="Mystery Client">
        <MysteryClientDashboard
          hostCompany={resolveHostCompany(user)}
          onLeftPanelChange={setLeftPanelOpen}
        />
      </section>

      {/* The drill-down sidebar opens over the top-left corner where the logo sits. */}
      <McClientLogo style={leftPanelOpen ? { display: 'none' } : undefined} />

      <ModuleSlider
        showNavbarControls={false}
        setShowNavbarControls={() => {}}
        showSimfixAreas={false}
        setShowSimfixAreas={() => {}}
        showPredictMode={false}
        setShowPredictMode={() => {}}
        showTlGreenWave={false}
        setShowTlGreenWave={() => {}}
        showAssignx={false}
        setShowAssignx={() => {}}
      />
    </>
  );
}

export default MysteryClient;
